import { render, staticRenderFns } from "./OMPrestationNotification.vue?vue&type=template&id=09e30644&scoped=true"
import script from "./OMPrestationNotification.vue?vue&type=script&lang=js"
export * from "./OMPrestationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e30644",
  null
  
)

export default component.exports